import { useDirection } from '@mantine/core';
import { ReactNode, createContext, useContext, useEffect } from 'react';

import { SupportedLocale } from '../../../common/types/SupportedLocale';
import { Direction } from '../../../utils/locale.utils';

type ContentLanguageContextType = {
  contentDirection: Direction;
  contentLanguage: SupportedLocale;
  isError: boolean;
  isLoading: boolean;
};

export const ContentLanguageContext = createContext<ContentLanguageContextType | null>(null);

export function useContentLanguage() {
  const ctx = useContext(ContentLanguageContext);
  if (ctx === null) throw new Error('ContentLanguageContext not initialized properly.');
  return ctx;
}

export const ContentLanguageProvider = ({
  children,
  contentDirection,
  contentLanguage,
  isError,
  isLoading
}: {
  children: ReactNode;
  contentDirection: Direction;
  contentLanguage: SupportedLocale;
  isError: boolean;
  isLoading: boolean;
}) => {
  const { setDirection, dir } = useDirection();

  useEffect(() => {
    if (dir !== contentDirection) {
      setDirection(contentDirection);
    }
  }, [contentDirection, setDirection, dir]);

  return (
    <ContentLanguageContext.Provider value={{ contentDirection, contentLanguage, isError, isLoading }}>
      {children}
    </ContentLanguageContext.Provider>
  );
};
